<div class="alternative-question-chart-report" *ngIf="!isLoading && results">
  <div class="alternative-question-chart-report__body">
    <ng-container *ngIf="results.type === 'date'">
      <div class="alternative-question-chart-report__body__result" *ngFor="let result of results.answers">
        <ng-container *ngIf="result.name">
          {{ result.name | date: 'dd/MM/yyyy' }}
        </ng-container>
        <ng-container *ngIf="!result.name">{{ 'DASHBOARD_FORMS.DETAIL.NO_RESULTS' | translate }}</ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="results.type === 'currency'">
      <div class="alternative-question-chart-report__body__result" *ngFor="let result of results.answers">
        <ng-container *ngIf="result.name">
          {{ result.name | currency: 'BRL':'symbol':'1.2-2' }}
        </ng-container>
        <ng-container *ngIf="!result.name">{{ 'DASHBOARD_FORMS.DETAIL.NO_RESULTS' | translate }}</ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="results.type === 'document'">
      <div class="alternative-question-chart-report__body__result" *ngFor="let result of results.answers">
        <ng-container *ngIf="result.name">
          {{ result.name | cpfCnpjFormat }}
        </ng-container>
        <ng-container *ngIf="!result.name">{{ 'DASHBOARD_FORMS.DETAIL.NO_RESULTS' | translate }}</ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="results.type === 'phone'">
      <div class="alternative-question-chart-report__body__result" *ngFor="let result of results.answers">
        <ng-container *ngIf="result.name">
          {{ result.name | phoneFormat }}
        </ng-container>
        <ng-container *ngIf="!result.name">{{ 'DASHBOARD_FORMS.DETAIL.NO_RESULTS' | translate }}</ng-container>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        results.type === 'shortAnswer' ||
        results.type === 'paragraph' ||
        results.type === 'hour' ||
        results.type === 'numeric' ||
        results.type === 'email'
      "
    >
      <div class="alternative-question-chart-report__body__result" *ngFor="let result of results.answers">
        <ng-container *ngIf="result.name">{{ result.name }}</ng-container>
        <ng-container *ngIf="!result.name">{{ 'DASHBOARD_FORMS.DETAIL.NO_RESULTS' | translate }}</ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="results.type === 'picture'">
      <div class="alternative-question-chart-report__body__result">
        <div class="alternative-question-chart-report__body__result__picture">
          <ng-container *ngFor="let result of results.answers">
            <a
              *ngIf="result.name"
              href="{{ result.name }}"
              [matTooltip]="'DASHBOARD_FORMS.DETAIL.IMAGE.TITLE' | translate"
              [matTooltipShowDelay]="500"
              target="_blank"
            >
              <img src="{{ result.name }}" />
            </a>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="results.type === 'multiplePicture'">
      <ng-container *ngFor="let result of results.answers">
        <div class="alternative-question-chart-report__body__result" *ngIf="result.values">
          <div class="alternative-question-chart-report__body__result__picture">
            <a
              *ngFor="let image of result.values"
              href="{{ image }}"
              target="_blank"
              [matTooltip]="'DASHBOARD_FORMS.DETAIL.IMAGE.TITLE' | translate"
              [matTooltipShowDelay]="500"
            >
              <img src="{{ image }}" />
            </a>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- SKELETON-LOADER -->

<div class="alternative-question-chart-report" *ngIf="isLoading">
  <div class="alternative-question-chart-report__header">
    <ngx-skeleton-loader *ngIf="title" [theme]="{ height: '18px', width: '200px', 'margin-bottom': '0px' }">
    </ngx-skeleton-loader>
  </div>

  <div class="alternative-question-chart-report__body">
    <div class="alternative-question-chart-report__body__legend">
      <ngx-skeleton-loader count="5" [theme]="{ height: '60px', 'margin-top': '12px', 'margin-bottom': '0px' }">
      </ngx-skeleton-loader>
    </div>
  </div>
</div>

<!-- /SKELETON-LOADER -->
